export default function Privacy() {
    return (
        <div className="container-tight max-w-3xl py-16 lg:py-24">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
                Legal
            </p>
            <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
                Privacy Policy
            </h1>
            <p className="mt-4 text-sm text-slate-500">Last updated: 1 February 2026</p>

            <div className="prose prose-slate dark:prose-invert mt-10 max-w-none text-slate-600 dark:text-slate-400 leading-relaxed space-y-6">
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        1. Information We Collect
                    </h2>
                    <p>
                        TenderTrackAI collects only the information necessary to provide
                        you with tender analysis services. This includes your name, work
                        email, company name, and the tender documents you upload. We do
                        not collect sensitive personal data unless explicitly required.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        2. How We Use Your Data
                    </h2>
                    <p>
                        Uploaded tender PDFs are processed solely for the purpose of
                        generating your analysis. We never share, resell, or train
                        third-party models on your documents. You can delete any uploaded
                        file from your dashboard at any time.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        3. Data Security
                    </h2>
                    <p>
                        All data is encrypted in transit (TLS 1.3) and at rest (AES-256).
                        Our infrastructure is hosted on ISO 27001 compliant cloud
                        providers within India.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        4. Your Rights
                    </h2>
                    <p>
                        Under the Digital Personal Data Protection Act, 2023, you may
                        request access, correction, or deletion of your personal data at
                        any time by writing to privacy@tendertrackai.com.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        5. Cookies
                    </h2>
                    <p>
                        We use only essential cookies required for authentication and
                        session management. No advertising or third-party tracking
                        cookies are placed without your explicit consent.
                    </p>
                </section>
                <section>
                    <h2 className="text-xl font-bold text-slate-900 dark:text-slate-50">
                        6. Contact
                    </h2>
                    <p>
                        For privacy queries, email privacy@tendertrackai.com or write to
                        TenderTrackAI Technologies Pvt. Ltd., Indiranagar, Bengaluru,
                        560038.
                    </p>
                </section>
            </div>
        </div>
    );
}
